import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  scrollViewContentContainer: {
    marginTop: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 39 : 20) : 39,
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : null
  },
  scrollViewContentContainerWithTray: {
    paddingBottom: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 260 : 220) : 250,
  },
  addUserContainerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  usersTitleTextStyle: {
    ...Fonts.type.bold,
    fontSize: 24,
  },
  usersTitleContainerStyle: {
    marginBottom: 20,
    marginTop: 15,
  },
  addUserTextStyle: theme => ({
    fontSize: 16,
    color: theme.colors.hyperlinkSix,
    marginTop: Platform.OS === 'ios' ? 6 : 0,
  }),
  addUserIconStyle: {
    marginLeft: 6,
    top: 2,
  },
  overlayLottie: {
    height: 200,
    width: 200,
  },
  errorIconStyle: {
    marginTop: 120,
  },
  loadingContainerStyle: {
    marginTop: 29.7,
  },
  subHeaderTitleContainerStyle: {
    marginTop: 10,
  },
  // vfScreenTitleStyle: { fontSize: 18.8 },
  subHeaderAfterSubTitleStyle: {
    fontSize: 18,
  },
  subHeaderDescriptionStyle: {
    fontSize: 16,
    color: Colors.mono5,
    marginBottom: -2,
    marginTop: 8,
  },
  manualRefreshContainerStyle: {
    marginBottom: 0,
    marginRight: -5,
  },
  usageValuesTextStyle: {
    color: Colors.dark_grey,
  },
  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
    marginHorizontal: 16,
  },
  titleTextStyle: {
    fontSize: 25,
    ...Fonts.type.bold,
  },
  secondLineStyle: {
    width: 190,
    height: 25,
  },
  secondLineContainerStyle: {
    width: 190,
    height: 25,
    marginBottom: 10,
  },
});
